export const checkPersonalIndentityCode = function(code) {
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code);
};
export const checkMobile = function(num) {
    return /^1\d{10}$/.test(num);
};
export const checkNum = function(num) {
    return /^([0-9]\d*|[0]{1,1})$/.test(num);
};